import BigNumber from 'bignumber.js'

export const db = {
  get(k, def = ''){
    let v = localStorage.getItem(k)
    return v? v: def
  },
  set(k, v){
    localStorage.setItem(k, v)
  }
}

export const formatBalance = (v, decimals = 18) => {
  if(!v) return ''
  return Number(v.div(new BigNumber(10**decimals)).toFixed(3, 1)).toLocaleString()
}

/**
 * 顶栏等窄位：最多 2 位小数；≥1万用紧凑记数。
 * @param {string} appLang 应用语言：`'en'` 强制 en-US（K/M）；`'zh'` 用 zh-CN（万 等）
 */
export const formatBalanceHeaderUsdt = (v, decimals = 18, appLang = 'en') => {
  if(v == null || v === '') return '0'
  let n
  try{
    n = new BigNumber(v).div(new BigNumber(10).pow(decimals))
  }catch(_e){
    return '0'
  }
  if(!n.isFinite() || n.isNaN() || n.lte(0)) return '0'
  if(n.gte(10000)){
    const x = Number(n.toFixed(12))
    if(!Number.isFinite(x)) return n.decimalPlaces(2, BigNumber.ROUND_DOWN).toFixed(2)
    const intlLocale = appLang === 'zh' ? 'zh-CN' : 'en-US'
    try{
      return new Intl.NumberFormat(intlLocale, { notation: 'compact', maximumFractionDigits: 2 }).format(x)
    }catch(_e){
      if(appLang === 'zh' && n.gte(1e4)){
        return `${n.div(1e4).decimalPlaces(2, BigNumber.ROUND_DOWN).toFixed()}万`
      }
      if(n.gte(1e6)) return `${n.div(1e6).decimalPlaces(2, BigNumber.ROUND_DOWN).toFixed()}M`
      return `${n.div(1e3).decimalPlaces(2, BigNumber.ROUND_DOWN).toFixed()}K`
    }
  }
  return n.decimalPlaces(2, BigNumber.ROUND_DOWN).toFixed(2)
}

export const sleep = s => {
  return new Promise(r => {
    setTimeout(r, s * 1000)
  })
}

export const api = (path, data) => {
  return new Promise((resolve, reject) => {
    fetch(path,
    (
    data
    ? {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      }
    } 
    :undefined
    )
    ).then(res=>res.json())
    .then(res => {
      if(res.code != 1){
        console.warn(res.msg)
        return reject(res.msg)
      }
      resolve(res.data)
    })
  })
}
